/** Ten sam szary, który backend nadaje kategorii bez wybranego koloru. */
export const DEFAULT_COST_CATEGORY_COLOR = '#9E9E9E';
